import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { vnApp_sentinelbi } from "../vnApp_sentinelbi";
import { sidebarMenu_template } from "./sidebarMenu_template";

declare var ko: any;

export class usersProfile_template extends vnTemplate{

    public sidebarMenu: sidebarMenu_template;

    protected getTemplateHtml(): string{

        return `

            <div class="page-header">
                <div class="flex">
                    <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
                    <h2 class="title-page">User</h2>
                </div>
            </div>

            <div class="nav-page-container">
            <div class="nav-page-grid">

                <div class="nav-page-sidebar" data-bind="visible: $data.sidebarMenu.isVisible()">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>

                <div class="nav-page-content">

                    <div class="user-profil">

                        <div class="user-header">
                            <button data-bind="visible: hasWriteAccess, event: { click: onClickEdit }" class="button-default icon i-edit" type="button"><span>Edit</span></button>

                            <div class="w-user-img"><img class="user-img" data-bind="attr:{src: pictureUrl}" alt=""></div>
                            <strong>
                                <span data-bind="text: firstName"></span>
                                <span data-bind="text: lastName"></span>
                            </strong>
                        </div>

                        <div class="user-infos">
                            <div class="user-infos-list">
                                <div class="w-form w-form-large">
                                    <div class="w-form-body">
                                        <div class="form-body full-width" style="border: 0">
                                            <div class="form-group">
                                                <ul class="brand-list" data-bind="foreach: userBrands">
                                                    <img data-bind="attr: {src: $data.iconUrl ? $data.iconUrl : $parent.defaultLogo()}" alt="dropdown">
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-form-body">
                                        <div class="form-body">

                                            <div class="form-group">
                                                <label for="accountName" class="form-label">First Name</label>
                                                <input id="accountName" data-bind="value: firstName, attr: { readonly: true }" type="text" class="input-text read-only">
                                            </div>
                                            <div class="form-group">
                                                <label for="accountName" class="form-label">Last Name</label>
                                                <input id="accountName" data-bind="value: lastName, attr: { readonly: true }" type="text" class="input-text read-only">
                                            </div>
                                        </div>
                                        <div class="form-body">
                                            <div class="form-group">
                                                <label for="accountName" class="form-label">User Name</label>
                                                <input id="accountName" data-bind="value: loginName, attr: { readonly: true }" type="text" class="input-text read-only">
                                            </div>
                                            <div class="form-group">
                                                <label for="accountName" class="form-label">Email</label>
                                                <input id="accountName" data-bind="value: email, attr: { readonly: true }" type="email" class="input-text read-only">
                                            </div>
                                            <div class="form-group">
                                                <label for="accountName" class="form-label">Role(s)</label>
                                                <input id="accountName" data-bind="value: roles, attr: { readonly: true }" type="email" class="input-text read-only">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                        </div>
                        <section class="remembered-browsers" data-bind="visible: rememberedDevicesEnabled, attr: {'aria-busy': rememberedDevicesBusy}">
                            <div class="profile-section-heading"><h3>Remembered browsers</h3></div>
                            <p class="profile-description">These browsers can sign you in automatically. Removing one requires a new login after its current session ends.</p>
                            <p class="browser-empty" data-bind="visible: activeRememberedDevices().length === 0">No browsers have remembered access.</p>
                            <ul class="remembered-browser-list" data-bind="foreach: activeRememberedDevices()">
                                <li class="remembered-browser" data-bind="css: {'is-current': isCurrent}">
                                    <div class="browser-heading">
                                        <div><strong data-bind="text: deviceName || browser || 'Browser'"></strong><span class="browser-current" data-bind="visible: isCurrent">This browser</span></div>
                                        <button class="btn browser-remove" type="button" data-bind="click: $parent.onRevokeDevice, enable: !$parent.rememberedDevicesBusy(), attr: {'aria-label': 'Remove remembered access for ' + (deviceName || browser || 'browser')}">Remove browser</button>
                                    </div>
                                    <dl class="browser-details">
                                        <div><dt>Browser / system</dt><dd><span data-bind="text: browser || 'Unknown'"></span> · <span data-bind="text: operatingSystem || 'Unknown'"></span></dd></div>
                                        <div><dt>IP address</dt><dd data-bind="text: ipAddress || 'Unknown'"></dd></div>
                                        <div><dt>First login</dt><dd data-bind="text: dateCreation"></dd></div>
                                        <div><dt>Last activity</dt><dd data-bind="text: dateLastUsed"></dd></div>
                                        <div><dt>Remembered until</dt><dd data-bind="text: dateExpires"></dd></div>
                                    </dl>
                                </li>
                            </ul>
                            <details class="browser-history" data-bind="visible: inactiveRememberedDevices().length > 0">
                                <summary>Previously remembered browsers <span data-bind="text: '(' + inactiveRememberedDevices().length + ')'"></span></summary>
                                <ul data-bind="foreach: inactiveRememberedDevices()">
                                    <li><div><strong data-bind="text: deviceName || browser || 'Browser'"></strong><span class="browser-history-meta"><span data-bind="text: ipAddress || 'Unknown IP'"></span> · Last activity: <span data-bind="text: dateLastUsed"></span></span></div><span class="browser-status" data-bind="text: status"></span></li>
                                </ul>
                            </details>
                            <div class="browser-actions" data-bind="visible: activeRememberedDevices().length > 0">
                                <span>Current sessions stay open.</span>
                                <div>
                                    <button class="btn browser-remove" type="button" data-bind="click: onRevokeOtherDevices, enable: !rememberedDevicesBusy()">Remove other browsers</button>
                                    <button class="btn browser-remove browser-remove-all" type="button" data-bind="click: onRevokeAllDevices, enable: !rememberedDevicesBusy()">Remove all browsers</button>
                                </div>
                            </div>
                        </section>
                        <p class="browser-message" role="status" data-bind="text: rememberedDevicesMessage, visible: rememberedDevicesMessage"></p>
                        </div>

                        <!--
                        <div class="w-form-body">
                            <div class="form-body">










                            </div>
                            <div class="form-body">
                                <strong class="form-sub-title">personal info</strong>
                                <div class="form-group">
                                    <legend class="form-legend">Roles</legend>
                                    <ul data-bind="foreach: roles">
                                        <li data-bind="text: $data"></li>
                                    </ul>

                                </div>

                                <div class="form-group">
                                    <legend class="form-legend">Projects</legend>
                                    <ul data-bind="foreach: brands">
                                        <li class="brand-item " data-bind="css: iconImage"></li>
                                    </ul>
                                </div>

                                <div class="w-img"><img data-bind="attr:{src: pictureUrl}" alt=""></div>

                            </div>

                        </div>
                        -->
                    </div>
                </div>
            `;
    }

    protected initPartial(): void {
        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-users');
    }

    protected getTemplateName(): string{
        return "usersProfile-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    protected buildViewModel(): any{
        let huit_neuf_this = this;

        return {
            idUser: ko.observable("")
            ,firstName: ko.observable("")
            ,lastName: ko.observable("")
            ,loginName: ko.observable("")
            ,hasWriteAccess: ko.observable(false)
            ,permissions: ko.observable([])
            ,email: ko.observable("")
            ,pictureUrl: ko.observable(null)
            ,roles: ko.observableArray([])
            ,userBrands: ko.observableArray([])
            ,rememberedDevicesEnabled: ko.observable(false)
            ,rememberedDevices: ko.observableArray([])
            ,activeRememberedDevices: () => this.getTemplateViewModel().rememberedDevices().filter(device => device.status === 'Active')
            ,inactiveRememberedDevices: () => this.getTemplateViewModel().rememberedDevices().filter(device => device.status !== 'Active')
            ,rememberedDevicesBusy: ko.observable(false)
            ,rememberedDevicesMessage: ko.observable("")
            ,onRevokeDevice: function(device) {
                huit_neuf_this.caller.changeRememberedDevices('device', device.id);
            }
            ,onRevokeOtherDevices: function() {
                huit_neuf_this.caller.changeRememberedDevices('others');
            }
            ,onRevokeAllDevices: function() {
                huit_neuf_this.caller.changeRememberedDevices('all');
            }
            ,isActive: ko.observable("")
            ,defaultLogo: ko.observable(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH)

            ,onClickEdit : function(data, event){ huit_neuf_this.onClickEdit(data.idUser())}
            //,onClickBack: function() { huit_neuf_this.onClickBack() }
            ,openSidebar: function() { huit_neuf_this.openSidebar() }
        }
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar() {

        this.sidebarMenu.setSidebarToggle(true);
    }

    public setHasWriteAccess(hasWriteAccess: boolean): void{this.getTemplateViewModel().hasWriteAccess(hasWriteAccess);}

    public setPermissions(permissions: any){
        this.getTemplateViewModel().permissions(permissions);
    }


    public setRoles(selectedRoles : Array<{name: string}>){
        let roles = [];
        for(let r of selectedRoles){
            roles.push(r.name);
        }
        this.getTemplateViewModel().roles(roles);
    }
/*
    public setBrands(selectedBrands : Array<{name: string}>){
        let brands = [];
        for(let r of selectedBrands){
            brands.push(r.name);
        }
        this.getTemplateViewModel().brands(brands);
    }
*/
    public setBrands(brands: any){
        this.getTemplateViewModel().userBrands(brands);
    }

    public onClickEdit(idUser){
        this.caller.editUser(idUser);
    }

    // public onClickBack(){
    //     this.caller.onClickBack();
    // }

}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfile_template.ts